import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61ccc024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between pl-5 pr-8 laptop:px-10 items-center h-[80px] z-20 sticky top-0 bg-white shadow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/trasko_logo.svg",
  class: "h-full"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "flex items-center uppercase text-sm text-black justify-between tablet:w-3/5 laptop:w-2/5 desktop:1/3"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Pro členy")
const _hoisted_5 = {
  key: 1,
  class: "icon hover:cursor-pointer"
}
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "flex flex-col fixed w-full h-calc(100%-80px) bg-white bottom-0 items-center overflow-hidden p-[100px] justify-between z-10" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Pro členy")

import {onMounted, ref} from 'vue'
import {MenuItem} from "@/interfaces/interfaces";

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const mobile = ref(false);
  const mobileNavOpened = ref(false)

  const menuItems = ref<Array<MenuItem>>([
    {
      name: 'O oddílu',
      link: '/o_oddilu',
    } as MenuItem,
    {
      name: 'Výsledky',
      link: '/vysledky',
    } as MenuItem,
    {
      name: 'Kalendář',
      link: '/kalendar',
    } as MenuItem,
  ])

  onMounted(() => {
    window.addEventListener('resize', checkScreen);
    checkScreen();
  })

  function toggleMobileNav(){
    mobileNavOpened.value = !mobileNavOpened.value;
  }

  function checkScreen(){
    if(window.innerWidth <= 640){
      mobile.value = true
      return
    }
    mobile.value = false
    mobileNavOpened.value = false
  }

  function getBarClassName(i: 1|2|3){
    if(mobileNavOpened.value){
      return 'bar'+ i + '-active'
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "h-full hover:scale-105 transition-all",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileNavOpened.value = false))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      (!mobile.value)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (menuItem) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: menuItem.link,
                class: "p-2 hover:text-orange transition-all",
                to: menuItem.link
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(menuItem.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128)),
            _createVNode(_component_router_link, {
              "active-class": "pro-cleny",
              class: "bg-primary py-2.5 px-3 rounded-2xl text-white",
              to: "/pro_cleny"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (mobile.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("i", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleMobileNav())),
              class: _normalizeClass(["fa-bars", {'icon-active' : mobileNavOpened.value}])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  id: 'bar' + i,
                  class: _normalizeClass(["w-[25px] h-[2px] bg-black rounded m-[7px] transition duration-500", getBarClassName(i)])
                }, null, 10, _hoisted_6)
              }), 64))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("nav", null, [
      _createVNode(_Transition, { name: "mobile-nav" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (menuItem) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: menuItem.link,
                class: "p-3",
                to: menuItem.link,
                onClick: toggleMobileNav
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(menuItem.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128)),
            _createVNode(_component_router_link, {
              "active-class": "pro-cleny",
              class: "bg-primary p-2.5 rounded-2xl text-white",
              to: "/pro_cleny",
              onClick: toggleMobileNav,
              exact: ""
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, mobileNavOpened.value]
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})